import { RedeemServiceError } from '@sitegen/common/types/redemption.types';
import { ERROR_CODES, HTTP_CODES } from './redemption.constants';
import { REDEMPTION_STATUS } from '../redemption.constants';

export const parseRedeemServiceError = (error: RedeemServiceError): REDEMPTION_STATUS => {
    const { httpCode = 0, errorCode = 0 } = error;
    switch (httpCode) {
    case HTTP_CODES.BAD_REQUEST: {
        switch (errorCode) {
        case ERROR_CODES.INVALID_CODE: return REDEMPTION_STATUS.INVALID_CODE;
        case ERROR_CODES.NOT_ELIGIBLE: return REDEMPTION_STATUS.NOT_ELIGIBLE;
        case ERROR_CODES.INVALID_PLATFORM:
        case ERROR_CODES.BENEFIT_NOT_SELECTED: return REDEMPTION_STATUS.SELECT_BENEFIT_REQUIRED;
        case ERROR_CODES.CODE_LIMIT_REACHED: return REDEMPTION_STATUS.CODE_ALREADY_REDEEMED;
        }
    }
    }
    return REDEMPTION_STATUS.GENERIC_ERROR;
};
